// extracted by mini-css-extract-plugin
export var aCol2 = "x";
export var aDetail = "z";
export var aGallery = "y";
export var aInfo = "A";
export var aInner = "w";
export var animationMarquee = "B";
export var lItemDetail = "v";